class StallionBar {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.button = self.elem.querySelector('[data-stallion-bar-toggle]');
    }

    init() {
        let self = this;

        document.addEventListener('DOMContentLoaded', function () {
            self.button.addEventListener('click', function () {
                self.elem.classList.toggle('is-open');
            });
        });
    }
}

export default StallionBar;
